import './CampaignHeader.scss';
import React from 'react';
import classNames from 'classnames';
function CampaignHeader({ title, image, textColor, backgroundColor, type, onClick, position = 'center', }) {
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };
    const classes = classNames({
        [`campaign-header campaign-header--${type}`]: !!type,
        'campaign-header--white': textColor === 'white',
        [`campaign-header campaign-header--banner__${position}`]: type === 'banner' && !!position,
    });
    let styles = {};
    if (type === 'banner') {
        styles = { backgroundColor: backgroundColor };
    }
    return (React.createElement("div", { className: classes, style: {
            backgroundImage: `url(${image})`,
        }, onClick: (e) => handleClick(e) }, title && (React.createElement("h1", { className: "campaign-header__title", style: styles }, title))));
}
export default CampaignHeader;
